import { Fragment } from "react";
import { Grid, Typography, Divider } from "@mui/material";
import Project from "./asset/projects.png";
import Help from "./asset/Help.png";
import Home from "./components/home";
import { useMediaQuery } from "@mui/material";

function Landingpage() {
  const matches = useMediaQuery("(min-width:900px)");
  return (
    <Fragment>
      <Home />
      <br />
      <Divider />
      <br />
      <br />
      <Typography variant={matches ? "h3" : "h4"} textAlign="center">
        How to get started
      </Typography>
      <Grid
        container
        direction="column"
        display="flex"
        alignItems="center"
        spacing={10}
        sx={{ py: 10, px: 5 }}
      >
        <Grid
          item
          container
          direction="column"
          display="flex"
          alignItems="center"
          spacing={4}
        >
          <Grid item textAlign="center">
            <Typography variant="h5">🚀 Ask any Query</Typography>
          </Grid>
          <Grid item textAlign="center">
            <Typography variant="subtile1">
              Ask ACC Copilot your queries about Autodesk Construction Cloud!
            </Typography>
          </Grid>
          <Grid item textAlign="center">
            <img src={Project} alt="get-ans" />
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="column"
          display="flex"
          alignItems="center"
          spacing={4}
        >
          <Grid item textAlign="center">
            <Typography variant="h5">
              🤝 Don't know how to use ACC Copilot?
            </Typography>
          </Grid>
          <Grid item textAlign="center">
            <Typography variant="subtile1">
              Don't worry just type Help or User guide our Copilot will guide
              you.
            </Typography>
          </Grid>
          <Grid item textAlign="center">
            <img src={Help} alt="get-ans" />
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Landingpage;
